import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';


class NationalCPFProvider extends BaseApi {
	getDealerCPF(input: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetAllDealersCPF`, { input });
	}
}
export const apiProvider = new NationalCPFProvider(DMS_MODULE, NAME);
